/**
 * @module M/control/maritimesignalsControl
* import { log } from 'handlebars';
*/

import MaritimeSignals from '../../impl/ol/js/maritimesignalscontrol';
import template from '../../templates/maritimesignals';
import templateResults from '../../templates/maritimesignalsresults';
import { getValue } from './i18n/language';

/**
 * @classdesc
 * maritimesignals Mapea control.
 */
export default class MaritimeSignalsControl extends M.Control {
  /**
   * @constructor
   * @extends {M.Control}
   * @api
   */
  constructor(options) {
    if (M.utils.isUndefined(MaritimeSignals)) {
      M.exception(getValue('exception.impl'));
    }
    const impl = new MaritimeSignals();
    super(impl, 'maritimesignals');

    /**
     * URL
     *
     * @private
     * @type {string}
     */
    this.url_ = options.url;

    /**
     * Search fields
     *
     * @private
     * @type {Array}
     */
    this.searchFields_ = options.searchFields;

    /**
     * Layer
     *
     * @private
     * @type {M.layer}
     */
    this.layer_ = null;

    /**
     * URL - Images
     *
     * @private
     * @type {String}
     */
    this.urlImages_ = options.urlImages;

    /**
     * Extension - Images
     *
     * @private
     * @type {String}
     */
    this.extensionImages_ = options.extensionImages;

    /**
     * Name default image
     *
     * @private
     * @type {String}
     */
    this.nameDefaultImage_ = options.nameDefaultImage;

    /**
     * Codes
     *
     * @private
     * @type {String}
     */
    this.codesImages_ = options.codesImages;

    /**
     * Codes Nie
     *
     * @private
     * @type {String}
     */
    this.codesNie_ = options.codesNie;

    /**
     * Left codes
     *
     * @private
     * @type {String}
     */
    this.leftCodes_ = options.leftCodes;

    /**
     * Warning
     *
     * @private
     * @type {String}
     */
    this.warning_ = options.warning;

    /**
     * Codes status
     *
     * @private
     * @type {Array}
     */
    this.codesStatus_ = options.codesStatus;

    /**
     * FItlers - zoom
     *
     * @private
     * @type {M.filter}
     */
    this.filtersZoom_ = [];

    /**
     * Zoom
     *
     * @private
     * @type {Number}
     */
    this.zoom_ = null;

    /**
     * Filters - search
     *
     * @private
     * @type {Number}
     */
    this.filterSearch_ = [];

    /**
     * array - cartas
     *
     * @private
     * @type {Number}
     */
    this.arraycartas_ = [];


    /**
     * array - cartas
     *
     * @private
     * @type {String}
     */
    this.caja_ = [];
  }

  /**
   * This function creates the view
   *
   * @public
   * @function
   * @param {M.Map} map to add the control
   * @api
   */
  createView(map) {
    return new Promise((success, fail) => {
      this.caja_ = document.createElement('div');
      this.caja_.className = 'm-maritimesignals-h5';
      document.body.appendChild(this.caja_);
      document.addEventListener('mousemove', (e) => {
        this.caja_.style.top = (e.clientY + 10).toString().concat('px');
        this.caja_.style.left = (e.clientX + 15).toString().concat('px');
        // this.caja_.style.display = 'none';
      });
      const html = M.template.compileSync(template, {
        vars: {
          translations: {
            title: getValue('headlightsFogSignals'),
            criteriaSourceCartography: getValue('criteriaSourceCartography'),
            nameLocationMaritime: getValue('nameLocationMaritime'),
            nameLocationCartas: getValue('nameLocationCartas'),
            location: getValue('location'),
            clear: getValue('clear'),
            restricted: getValue('restricted'),
            selcartas: getValue('selcartas'),
            loadlayer: getValue('loadlayer'),
            RescriteriaSourceCartography: getValue('RescriteriaSourceCartography'),
            infotxt: getValue('infotxt'),
          },
        },
      });
      this.template_ = html;
      const btn = html.querySelector('#m-searchtopomarina-locate-button');
      const btnClear = html.querySelector('#m-searchtopomarina-clear-button');
      const btnLoad = html.querySelector('#m-searchtopomarina-upload');
      btnLoad.addEventListener('click', this.loadFile_.bind(this), false);
      const input = html.querySelector('#m-maritimesignals-input');
      const checkedres = html.querySelector('#m-searchtopomarina-restricted');
      checkedres.addEventListener('click', (event) => {
        if (event.target.checked) {
          this.template_.querySelector('#m-maritimesignals-legend').innerHTML = getValue('RescriteriaSourceCartography');
        } else {
          this.template_.querySelector('#m-maritimesignals-legend').innerHTML = getValue('criteriaSourceCartography');
        }
      }, false);
      btn.addEventListener('mousedown', (event) => {
        this.template_.querySelector('.m-maritimesignals-spinner').style.display = 'block';
        this.template_.querySelector('#m-maritimesignals-results').innerHTML = '';
      }, false);
      btn.addEventListener('mouseup', this.search.bind(this), false);
      btnClear.addEventListener('click', this.clearResults.bind(this), false);
      input.addEventListener('keyup', (event) => {
        if (event.keyCode === 13) {
          this.search(event);
        }
      }, false);
      input.addEventListener('keydown', (event) => {
        if (event.keyCode === 13) {
          this.template_.querySelector('.m-maritimesignals-spinner').style.display = 'block';
          this.template_.querySelector('#m-maritimesignals-results').innerHTML = '';
        }
      }, false);
      // muestra la pantalla de bienvenida si la peticion procede del libro faros
      const callPath = window.location.pathname;
      // console.log('Location ', callPath);
      if (callPath === '/apps_ihm/librofaros/index.html' || callPath === '/apps_ihm/librofaros/index_en.html') {
        window.addEventListener('load', this.showAyuda_.bind(this), false);
        // carga de la capa tras la carga
        window.addEventListener('load', this.loadFile_.bind(this), false);
      }
      this.map = map;
      success(html);
    });
  }

  decodRitmo(ritmo) {
    let ritmoOut = '';
    const aTimeOn = [];
    const aTimeOff = [];
    let nIters = 0;
    const arrayReturn = [];
    switch (ritmo) {
      case 0:
        ritmoOut = 'Ciega';
        aTimeOn.push(0);
        aTimeOff.push(0);
        break;
      case 1:
        ritmoOut = 'Fija';
        aTimeOn.push(1);
        aTimeOff.push(0);
        break;
      case 2:
        ritmoOut = 'ISO';
        aTimeOn.push(2);
        aTimeOff.push(2);
        break;
      case 3:
        ritmoOut = 'Morse_A (boyas Aguas Navegables)';
        aTimeOn.push(0.5, 1.5);
        aTimeOff.push(0.5, 4.5);
        break;
      case 4:
        ritmoOut = 'Morse_U (plataformas)';
        aTimeOn.push(1, 1, 2);
        aTimeOff.push(0.1, 0.1, 10.8);
        break;
      case 5:
        ritmoOut = 'D (Destello)';
        aTimeOn.push(0.5);
        aTimeOff.push(4.5);
        break;
      case 6:
        ritmoOut = 'GpD(2)';
        aTimeOn.push(0.5, 0.5);
        aTimeOff.push(1.5, 4.5);
        break;
      case 7:
        ritmoOut = 'GpD(2+1)';
        aTimeOn.push(0.5, 0.5, 0.5);
        aTimeOff.push(0.7, 2.1, 5, 7);
        break;
      case 8:
        ritmoOut = 'GpD(3)';
        aTimeOn.push(0.5, 0.5, 0.5);
        aTimeOff.push(1.5, 1.5, 4.5);
        break;
      case 9:
        ritmoOut = 'GpD(4)';
        aTimeOn.push(0.5, 0.5, 0.5, 0.5);
        aTimeOff.push(1.5, 1.5, 1.5, 4.5);
        break;
      case 10:
        ritmoOut = 'GpD(5)';
        aTimeOn.push(0.4, 0.4, 0.4, 0.4, 0.4);
        aTimeOff.push(2, 2, 2, 2, 5);
        break;
      case 11:
        ritmoOut = 'DL (Destello Largo)';
        aTimeOn.push(3);
        aTimeOff.push(7);
        break;
      case 12:
        ritmoOut = 'GpDL(2)';
        aTimeOn.push(2, 2);
        aTimeOff.push(3, 5);
        break;
      case 13:
        ritmoOut = ' Ct (Centelleos)';
        aTimeOn.push(0.2);
        aTimeOff.push(0.8);
        break;
      case 14:
        ritmoOut = ' GpCt(2)';
        aTimeOn.push(0.3, 0.3);
        aTimeOff.push(0.7, 2.7);
        break;
      case 15:
        ritmoOut = ' GpCt(2+1)';
        aTimeOn.push(0.3, 0.3, 0.3);
        aTimeOff.push(0.4, 1.2, 3.5);
        break;
      case 16:
        ritmoOut = ' GpCt(3)';
        aTimeOn.push(0.3, 0.3, 0.3);
        aTimeOff.push(0.7, 0.7, 7.7);
        break;
      case 17:
        ritmoOut = ' GpCt(4)';
        aTimeOn.push(0.3, 0.3, 0.3, 0.3);
        aTimeOff.push(0.7, 0.7, 0.7, 6.7);
        break;
      case 18:
        ritmoOut = ' GpCt(5) (ODAS)';
        aTimeOn.push(0.3, 0.3, 0.3, 0.3, 0.3);
        aTimeOff.push(0.7, 0.7, 0.7, 0.7, 15.7);
        break;
      case 19:
        ritmoOut = ' Rapida (Card N)';
        aTimeOn.push(0.2);
        aTimeOff.push(0.3);
        break;
      case 20:
        ritmoOut = ' GpRp(2)';
        aTimeOn.push(0.2, 0.2);
        aTimeOff.push(0.3, 3.3);
        break;
      case 21:
        ritmoOut = ' GpRp(2+1)';
        aTimeOn.push(0.2, 0.2, 0.2);
        aTimeOff.push(0.3, 0.3, 3.8);
        break;
      case 22:
        ritmoOut = ' GpRp(3) (Card E)';
        aTimeOn.push(0.2, 0.2, 0.2);
        aTimeOff.push(0.3, 0.3, 3.8);
        break;
      case 23:
        ritmoOut = ' GpRp(4)';
        aTimeOn.push(0.2, 0.2, 0.2, 0.2);
        aTimeOff.push(0.3, 0.3, 0.3, 3.8);
        break;
      case 24:
        ritmoOut = ' GpRp+DL (Card S)';
        aTimeOn.push(0.2, 0.2, 0.2, 0.2, 0.2, 0.2, 2);
        aTimeOff.push(0.3, 0.3, 0.3, 0.3, 0.3, 0.3, 5);
        break;
      case 25:
        ritmoOut = ' GpRp(9) (Card W)';
        aTimeOn.push(0.2, 0.2, 0.2, 0.2, 0.2, 0.2, 0.2, 0.2, 0.2);
        aTimeOff.push(0.3, 0.3, 0.3, 0.3, 0.3, 0.3, 0.3, 0.3, 5.8);
        break;
      case 26:
        ritmoOut = ' Oc (Ocultaciones)';
        aTimeOn.push(3);
        aTimeOff.push(1);
        break;
      case 27:
        ritmoOut = ' Oc(2)';
        aTimeOn.push(3, 1);
        aTimeOff.push(1, 1);
        break;
      case 28:
        ritmoOut = ' Oc(3)';
        aTimeOn.push(3, 1, 1);
        aTimeOff.push(1, 1, 1);
        break;
      case 29:
        ritmoOut = ' Oc(4)';
        aTimeOn.push(3, 1, 1, 1);
        aTimeOff.push(1, 1, 1, 1);
        break;
      case 30:
        ritmoOut = 'Alt (Naufragio)';
        aTimeOn.push(1, 1);
        aTimeOff.push(0.5, 0.5);
        break;
      case 31:
        ritmoOut = 'Alt (Alternativa)';
        aTimeOn.push(1, 1);
        aTimeOff.push(1, 1);
        break;
      case 32:
        ritmoOut = ' GpU';
        aTimeOn.push(0.1, 0.1);
        aTimeOff.push(0.1, 10.7);
        break;
        // FAROS
      case 33:
        ritmoOut = ' GpOc(2+1)';
        aTimeOn.push(3, 3, 1);
        aTimeOff.push(1, 1, 1);
        break;
      case 34:
        ritmoOut = ' GpD(1+2)';
        aTimeOn.push(1, 1, 1);
        aTimeOff.push(3, 1, 3);
        break;
      case 35:
        ritmoOut = ' GpD(1+3)';
        aTimeOn.push(0.5, 0.5, 0.5, 0.5);
        aTimeOff.push(3.5, 1.5, 1.5, 3.5);
        break;
      case 36:
        ritmoOut = ' GpD(1+4)';
        aTimeOn.push(0.5, 0.5, 0.5, 0.5, 0.5);
        aTimeOff.push(3, 1.5, 1.5, 1.5, 10);
        break;
      case 37:
        ritmoOut = ' GpD(2+3)';
        aTimeOn.push(0.4, 0.4, 0.4, 0.4, 0.4);
        aTimeOff.push(2, 2, 6, 2, 6);
        break;
      case 38:
        ritmoOut = ' GpD(2+4)';
        aTimeOn.push(0.4, 0.4, 0.4, 0.4, 0.4, 0.4);
        aTimeOff.push(2.5, 8.8, 2.5, 2.5, 2.5, 8.8);
        break;
      case 39:
        ritmoOut = ' GpD(3+1)';
        aTimeOn.push(0.5, 0.5, 0.5, 0.5);
        aTimeOff.push(1, 1, 3, 3);
        break;
      case 40:
        ritmoOut = ' GpD(3+2)';
        aTimeOn.push(0.3, 0.3, 0.3, 0.3, 0.3);
        aTimeOff.push(1.4, 1.4, 7.1, 1.4, 7.2);
        break;
      case 41:
        ritmoOut = ' GpD(4+1)';
        aTimeOn.push(0.4, 0.4, 0.4, 0.4, 0.4);
        aTimeOff.push(1.8, 1.8, 1.8, 6.3, 6.3);
        break;
      case 42:
        ritmoOut = ' GpOc(1+3)';
        aTimeOn.push(3, 3, 1, 1);
        aTimeOff.push(1, 1, 1, 1);
        break;
      case 43:
        ritmoOut = ' GpOc(1+4)';
        aTimeOn.push(4.4, 4.4, 1.4, 1.4, 1.4);
        aTimeOff.push(1, 1, 1, 1, 1);
        break;
      case 44:
        ritmoOut = ' GpOc(1+2)';
        aTimeOn.push(4.5, 4.5, 1.5);
        aTimeOff.push(1, 1, 1);
        break;
      default:
        ritmoOut = ' x defecto';
        aTimeOn.push(7, 7, 7);
        aTimeOff.push(0.5, 0.5, 0.5);
        break;
    }
    nIters = aTimeOn.length;
    arrayReturn.push(ritmoOut, aTimeOn, aTimeOff, nIters);
    return arrayReturn;
  }

  parpadea(target, arrTimeOn, arrTimeOff, Iters, ritmo) {
    if (ritmo === 30) { // ritmo alternativo
      document.getElementById('m-signals-canvas_in').parentElement.style.backgroundColor = 'white';
    }
    if (ritmo === 31) { // ritmo alternativo
      document.getElementById('m-signals-canvas_in').parentElement.style.backgroundColor = 'green';
    }
    if (ritmo !== 1) {
      const nMaxVeces = 25;
      for (let nVeces = 0; nVeces < nMaxVeces; nVeces += 1) {
        for (let k = 0; k < Iters; k += 1) {
          target.animate({ opacity: '1' }, 0).delay(arrTimeOn[k] * 1000);
          target.animate({ opacity: '0' }, 0).delay(arrTimeOff[k] * 1000);
        }
      }
    }
    target.animate({ opacity: '1.0' }, 0);
  }


  /**
   * This function show popup
   *
   * @private
   * @function
   * @api
   */
  clickFeature_(features) {
    if (M.utils.isUndefined(features[0])) {
      return true;
    }
    const coordinates = features[0].getGeometry().coordinates;
    const tabs = [];
    const feature = features[0];
    const attributes = feature.getAttributes();
    const rit = attributes.rit;
    const sec = attributes.sec;
    let kol = M.utils.isUndefined(attributes.kol) ? attributes.kol : attributes.kol.charAt(0);
    if (kol === 'G') {
      kol = 'rgba(0,128,0,0.6)';
    } else if (kol === 'W') {
      kol = 'rgba(255,255,255,0.6)';
    } else if (kol === 'Y') {
      kol = 'rgba(255,255,0,0.6)';
    } else if (kol === 'R') {
      kol = 'rgba(255,0,0,0.6)';
    } else if (kol === 'B') {
      kol = 'rgba(0,0,255,0.8)';
    } else {
      kol = 'rgba(255,0,255,0.6)';
    }
    const arrDecodLuz = this.decodRitmo(parseInt(rit, 10));
    const arrTimeOn = arrDecodLuz[1];
    const arrTimeOff = arrDecodLuz[2];
    const iters = arrDecodLuz[3];
    let status = attributes.st;
    if (!M.utils.isUndefined(status)) {
      status = parseInt(status, 10).toString(2).length.toString();
      status = this.codesStatus_['cod_'.concat(status)];
    } else {
      status = '';
    }
    const cartas = M.utils.isUndefined(attributes.cart) ? '...' : attributes.cart;
    const nohayritmo = M.utils.isUndefined(attributes.rit);
    const noessector = M.utils.isUndefined(attributes.sec_);
    const aparpe = M.utils.isUndefined(attributes.apa) ? '' : attributes.apa;
    const sector = M.utils.isUndefined(attributes.sec_) ? '' : attributes.sec_;
    let nie = M.utils.isUndefined(attributes.nie_) ? '' : attributes.nie_;
    let niebla_txt = '';
    if (nie !== '') {
      nie = parseInt(nie, 10);
      nie = nie.toString(2);
      nie = nie.length >= 12 ? nie : new Array((12 - nie.length) + 1).join('0') + nie;
      nie = nie.split('').reverse().join('');
      const positions = [];
      for (let i = 0; i < 13; i += 1) {
        const value = nie.charAt(i);
        if (value === '1') {
          positions.push(i);
        }
      }
      niebla_txt = this.decodeNiebla(positions);
    }
    const num = M.utils.isUndefined(attributes.num) ? '' : attributes.num;
    const estado = M.utils.isUndefined(attributes.st) ? '' : 'Estado: '.concat(status);
    const nomgeo = M.utils.isUndefined(attributes.ngeo) ? '' : attributes.ngeo;
    const c1 = M.utils.isUndefined(attributes.c1) ? '' : attributes.c1;
    const c2 = M.utils.isUndefined(attributes.c2) ? '' : attributes.c2;
    const c3 = M.utils.isUndefined(attributes.c3) ? '' : attributes.c3;
    const c4 = M.utils.isUndefined(attributes.c4) ? '' : attributes.c4;
    const hayFoto = M.utils.isUndefined(attributes.fot) ? 0 : 1;
    const sop = M.utils.isUndefined(attributes.sop) ? '' : attributes.sop;
    const elevacion = M.utils.isUndefined(attributes.ele) ? '' : attributes.ele.concat('m');
    let alcance = M.utils.isUndefined(attributes.alc_) ? '' : attributes.alc_;
    if (typeof alcance === 'number') {
      alcance = alcance.concat('M');
    }
    let contentritmodata = '';
    if (!nohayritmo) {
      let contentritmo = '';
      if (!M.utils.isUndefined(sec)) {
        const svg = this.decodSectorPNOA('', alcance, sec, '');
        const img = `data:image/svg+xml;base64,${window.btoa(svg)}`;
        contentritmo = `<div id='m-signals-canvas_sector'
        style = 'background-image: url(${img}); background-position: top 17.5px left 17.5px; 
        background-size: contain; background-repeat: no-repat;'></div>
        </div>`;
      } else {
        contentritmo = `<div id='m-signals-canvas'>
          <div id='m-signals-canvas_in' style='background: ${kol};'></div>
          </div>`;
      }
      contentritmodata = `<div style='display: flex'>
          <div style='float: left; margin-right: 15px; min-width: 180px; max-width: 200px;'> 
            <p style='color: #193063'>${sector} </p>
            <p style='color: #193063'>${niebla_txt} </p>
          </div>
          <div id='destellador'>${contentritmo}</div>
        </div>`;
    }

    const charts_lbl = getValue('titlecharts');
    const content_cartas = `<div><b>${charts_lbl}: ${cartas}</b></div>`;
    let content = `<div class='xivato'>
      <div style='display: flex'>
        <div style='float: left; margin-right: 15px; min-width: 180px; max-width: 200px;'> 
          <p style='font-weight: bold; color: #193063'>${nomgeo} </p>
          <p>${c1}</p>
          <p>${c2}</p>
          <p>${c3}</p>
          <p>${c4}</p>
          <p style='color: red; font-weight: bold;'>${estado}</p>
          <p style='color: #193063'>${attributes.lat_}</p>
          <p style='color: #193063'>${attributes.lon_}</p>
          <p style='font-weight: bold; color: #193063'>${aparpe} ${elevacion} ${alcance}</p>`;
    if (hayFoto !== 1) { // muestra desorp por ausencia de foto
      content += `
        <p style='font-weight: bold; color: #193063'>${sop}</p>`;
    }
    content += '</div>';
    if (hayFoto === 1) {
      content += `
      <div style='float: right'><img style='border-radius: 10%; max-width: 100px; max-height: 150px' 
          src=${this.urlImages_}${attributes.num}${this.extensionImages_} onerror="this.src='./signals/${this.nameDefaultImage_}';" ></div>`;
    } else { // muestra no foto
      content += `
      <div style='float: right'><img style='border-radius: 10%; max-width: 100px; max-height: 150px' src='./signals_v3/${this.nameDefaultImage_}' ></div>`;
    }
    content += '</div>'.concat(contentritmodata);
    content += content_cartas;
    const featureTabOpts = {
      icon: 'g-cartografia-pin',
      title: 'Señal marítima '.concat(num),
      content,
    };
    tabs.push(featureTabOpts);

    const popup1 = new M.Popup({
      panMapIfOutOfView: true,
      ani: null,
    });
    tabs.forEach((tab) => {
      popup1.addTab(tab);
    });
    this.map.addPopup(popup1, coordinates);
    if (!nohayritmo) {
      if (!noessector) {
        this.parpadea(window.$(document.getElementById('m-signals-canvas_sector')), arrTimeOn, arrTimeOff, iters, rit);
      } else {
        if (rit !== 30 || rit !== 31) {
          this.parpadea(window.$(document.getElementById('m-signals-canvas_in')), arrTimeOn, arrTimeOff, iters, rit);
        }
        if (rit === 30) { // ritmo alternativo
          this.parpadea(window.$(document.getElementById('m-signals-canvas_in')), arrTimeOn, arrTimeOff, iters, rit);
        }
        if (rit === 31) { // ritmo alternativo
          this.parpadea(window.$(document.getElementById('m-signals-canvas_in')), arrTimeOn, arrTimeOff, iters, rit);
        }
      }
    }
    return true;
  }

  /**
   * This function show texto en cursor
   *
   * @private
   * @function
   * @api
   */
  hoverFeature_(features) {
    const feature = features[0];
    const attributes = feature.getAttributes();
    const nomgeo = M.utils.isUndefined(attributes.ngeo) ? '' : ' - '.concat(attributes.ngeo);
    this.caja_.innerHTML = `${attributes.num}${nomgeo}`;
    this.caja_.style.display = 'block';
  }

  /**
   * This function elimina texto del cursor
   *
   * @private
   * @function
   * @api
   */
  leaveFeature_(features) {
    this.caja_.innerHTML = '';
    // this.caja_.style.display = 'none';
  }

  showAyuda_() {
    const iconico = '<img id="escudo_ico" width="50" height="50" src="escudo_ico_bco.png" style="margin-right: 50px;"/>';
    let titulin_lbl = iconico;
    titulin_lbl += getValue('titleayuda');
    let ayuda0_lbl = getValue('ayuda0');
    ayuda0_lbl += getValue('ayuda1');
    ayuda0_lbl += getValue('ayuda2');
    ayuda0_lbl += getValue('ayuda3');
    ayuda0_lbl += getValue('ayuda4');
    ayuda0_lbl += getValue('ayuda5');
    ayuda0_lbl += getValue('ayuda6');
    M.dialog.info(ayuda0_lbl);
    document.querySelector('.m-title').innerHTML = titulin_lbl;
    return true;
  }

  /**
   * This function load file json
   *
   * @public
   * @function
   * @api
   */
  loadFile_() {
    const hayproxy = false; // M.proxy();
    if (this.url_.startsWith(window.location.origin)) { M.proxy(false); }
    this.template_.querySelector('.m-maritimesignals-btn').style.display = 'none';
    this.template_.querySelector('.m-maritimesignals-spinner').style.display = 'block';
    this.layer_ = new M.layer.GeoJSON({
      url: this.url_,
      name: 'Signals',
    }, { displayInLayerSwitcher: false });
    const features = this.layer_.getFeatures();
    this.layer_.on(M.evt.LOAD, () => {
      this.layer_.on(M.evt.SELECT_FEATURES, this.clickFeature_.bind(this), false);
      this.layer_.on(M.evt.HOVER_FEATURES, this.hoverFeature_.bind(this), false);
      this.layer_.on(M.evt.LEAVE_FEATURES, this.leaveFeature_.bind(this), false);
      this.filterLayer([]);
      this.setFiltersZoom_();
      const arrcartas = [];
      features.forEach((elm) => {
        const attributes = elm.getAttributes();
        if (!M.utils.isUndefined(attributes.cart)) {
          const cartas = attributes.cart.split(',');
          for (let i = 0; i < cartas.length; i += 1) {
            arrcartas.push(cartas[i]);
          }
        }
      });
      this.arraycartas_ = [...new Set(arrcartas)].sort();
      this.template_.querySelector('.m-maritimesignals-spinner').style.display = 'none';
      this.template_.querySelector('.m-maritimesignals-datas').style.display = 'block';
      const select = document.getElementById('m-maritimesignals-cartas');
      for (let i = 0; i <= this.arraycartas_.length; i += 1) {
        const opt = document.createElement('option');
        opt.value = this.arraycartas_[i];
        opt.innerHTML = this.arraycartas_[i];
        select.appendChild(opt);
      }
    });
    this.map.addLayers(this.layer_);
    M.proxy(hayproxy);
  }

  /**
   * This function filter by zoom
   *
   * @public
   * @function
   * @api
   */
  setFiltersZoom_() {
    this.map.getMapImpl().on('moveend', () => {
      /* eslint-disable-next-line max-len */
      const hayfeatures = this.layer_.getFeatures().length !== 0 || this.filterSearch_.length !== 0 || this.filtersZoom_ !== 0;
      if (this.zoom_ !== this.map.getZoom() && hayfeatures) {
        this.setConditionalZoom_();
      }
    });
  }


  setConditionalZoom_() {
    const flt = [];
    let i;
    this.zoom_ = this.map.getZoom();
    this.layer_.removeFilter(this.filtersZoom_);
    if (this.map.getZoom() >= 0 && this.map.getZoom() <= 9) {
      for (i = 20; i < 100; i += 1) {
        flt.push(M.filter.EQUAL('alc', i.toString()));
      }
    } else if (this.map.getZoom() > 9 && this.map.getZoom() < 14) {
      for (i = 5; i < 100; i += 1) {
        flt.push(M.filter.EQUAL('alc', i.toString()));
      }
    } else if (this.map.getZoom() >= 14) {
      flt.push(M.filter.NOT(M.filter.EQUAL('num', 'nulo')));
    }
    let filterOr = M.filter.OR(flt);
    if (this.filterSearch_.length !== 0) {
      filterOr = M.filter.AND([this.filterSearch_, filterOr]);
    }
    this.layer_.setFilter(filterOr);
    // console.log('setConditionalZoom ', flt);
  }

  /**
   * This function search by name, location or maritime signal
   *
   * @public
   * @function
   * @api
   */
  inExtent(feature) {
    const mapView = this.map.getMapImpl().getView();
    const extent = mapView.calculateExtent(this.map.getMapImpl().getSize());
    const minx = extent[0];
    const miny = extent[1];
    const maxx = extent[2];
    const maxy = extent[3];
    const lat = feature.getGeometry().coordinates[1];
    const lon = feature.getGeometry().coordinates[0];
    if (lat > miny && lat < maxy && lon > minx && lon < maxx) {
      return true;
    }
    return false;
  }


  /**
   * This function search by name, location or maritime signal
   *
   * @public
   * @function
   * @api
   */
  inChart(feature) {
    const attributes = feature.getAttributes();
    let cartas = M.utils.isUndefined(attributes.cart) ? 'x' : attributes.cart;
    cartas = cartas.split(',');
    if (cartas.length > 0) {
      for (let i = 0; i < cartas.length; i += 1) {
        if (document.getElementById('m-maritimesignals-cartas').value.toLowerCase() === cartas[i].toLowerCase()) {
          return true;
        }
      }
    }
    return false;
  }


  /**
   * This function search by name, location or maritime signal
   *
   * @public
   * @function
   * @api
   */
  search(e) {
    this.template_.querySelector('.m-maritimesignals-spinner').style.display = 'block';
    this.template_.querySelector('.m-maritimesignals-datas').style.display = 'none';
    this.template_.querySelector('#m-maritimesignals-results').innerHTML = '';
    if (e.target.id === 'm-searchtopomarina-locate-button') {
      // e.target.value = e.target.previousElementSibling.value;
      e.target.value = document.getElementById('m-maritimesignals-input').value;
    }
    this.setVisibleLayer(false);
    this.layer_.removeFilter(this.filterSearch_);
    const cartasvalue = document.getElementById('m-maritimesignals-cartas').value;
    // const cartascheck = document.getElementById('m-searchtopomarina-selcartas').checked;
    const restricheck = document.getElementById('m-searchtopomarina-restricted').checked;
    const result = this.layer_.getFeatures().filter((feature) => {
      let filter = false;
      this.searchFields_.forEach((element) => {
        if (!M.utils.isUndefined(feature.getAttribute(element)) &&
          feature.getAttribute(element).toLowerCase().indexOf(e.target.value.toLowerCase()) > -1) {
          filter = true;
          // if (restricheck && (cartascheck && !(cartasvalue === ''))) {
          if (restricheck && !(cartasvalue === '')) {
            filter = this.inExtent(feature) && this.inChart(feature);
          }
          // if ((cartascheck && !(cartasvalue === '')) && !restricheck) {
          if (!(cartasvalue === '') && !restricheck) {
            filter = this.inChart(feature);
          }
          // if (!(cartascheck && !(cartasvalue === '')) && restricheck) {
          if (cartasvalue === '' && restricheck) {
            filter = this.inExtent(feature);
          }
        }
      });
      return filter;
    });
    this.template_.querySelector('.m-maritimesignals-spinner').style.display = 'none';
    this.template_.querySelector('.m-maritimesignals-datas').style.display = 'block';
    this.showResults(result);
  }

  polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    const a = (angleInDegrees + 90);
    const b = Math.PI;
    const c = 180.0;
    const angleInRadians = (a * b) / c;
    return {
      x: centerX + (radius * Math.cos(angleInRadians)),
      y: centerY + (radius * Math.sin(angleInRadians)),
    };
  }

  decodKol(kol) {
    let color = '';
    switch (kol) {
      case 't':
        color = 'rgba(0,0,0,0),t';
        break;
      case '#ffffff':
      case 'b':
      case 'w':
      case 'white':
        color = 'white';
        break;
      case 'wu':
        color = 'white,u';
        break;
      case 'wi':
        color = 'white,i';
        break;
      case '#ff0000':
      case 'r':
      case 'red':
        color = 'red';
        break;
      case 'ri':
        color = 'red,i';
        break;
      case 'ru':
        color = 'red,u';
        break;
      case '#00ff00':
      case 'v':
      case 'g':
      case 'green':
        color = 'green';
        break;
      case 'gi':
        color = 'green,i';
        break;
      case 'gu':
        color = 'green,u';
        break;
      case '#ffff00':
      case 'a':
      case 'y':
      case 'yellow':
        color = 'yellow';
        break;
      default:
        color = 'magenta';
    }
    return color;
  }

  drawSectorPNOA(sym, alc, startAngle0, endAngle0, kol) {
    const cx = 0;
    const cy = 0;
    let radius = 100;
    if (sym === '156') {
      if (alc > 7) {
        radius = 42;
      } else {
        radius = 25;
      }
    }
    const start = this.polarToCartesian(cx, cy, radius, endAngle0);
    const end = this.polarToCartesian(cx, cy, radius, startAngle0);
    const largeArcFlag = endAngle0 - startAngle0 <= 180 ? '0' : '1';
    const pathDescription = [
      'M', cx, cy,
      'L', start.x, start.y,
      'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y,
      'Z',
    ].join(' ');
    const color = this.decodKol(kol).split(',');
    const fill = color[0];
    let fillOpacity = 0;
    if (color.length === 2) {
      switch (color[1]) {
        case 'i':
          fillOpacity = 0.8;
          break;
        case 'u':
          fillOpacity = 0.4;
          break;
        default:
          fillOpacity = 0.6;
      }
      // fillOpacity = (color[1] === 'i') ? 0.6 : ((color[1] === 'u') ? 0.2 : 0.1);
    } else {
      fillOpacity = 0.7;
    }
    if (kol === 't') { fillOpacity = 0.1; }
    const path = `<circle cx="${cx}" cy="${cx}" r="5" fill="none" stroke-width="1.5px" stroke="black" transform="scale(0.3, 0.3)" transform-origin="50% 50%" /><path d="${pathDescription}" fill="${fill}" fill-opacity="${fillOpacity}" transform="scale(0.3, 0.3)" transform-origin="50% 50%"></path>`;
    return path;
  }

  decodSectorPNOA(sym, alc, sectoresIn, posicion) {
    let pathCompleto = '';
    let startAngle0;
    let endAngle0;
    let color;
    let alc_ = alc;
    if (M.utils.isUndefined(posicion)) {
      alc_ = 25;
    }
    let nextStartAngle0;
    const ang = /([0-9.$]+)/g;
    const kol = /([^0-9.\s]+)/g; // detecta obscd
    const sectores = sectoresIn.match(ang);
    let sectoresIn_ = sectoresIn;
    sectoresIn_ = sectoresIn_.toLowerCase();
    const Nsectores = sectores.length;
    const coloretes = sectoresIn_.match(kol);
    for (let i = 0; i < Nsectores - 1; i += 1) {
      if (i === 0) {
        startAngle0 = parseInt(sectores[i], 10);
      } else {
        startAngle0 = nextStartAngle0;
      }
      color = (coloretes[i] !== '') ? coloretes[i] : 'y';
      endAngle0 = parseInt(sectores[i + 1], 10);
      nextStartAngle0 = endAngle0;
      if (startAngle0 > endAngle0) {
        pathCompleto += this.drawSectorPNOA(sym, alc_, startAngle0, 360, color);
        pathCompleto += this.drawSectorPNOA(sym, alc_, 0, endAngle0, color);
      } else {
        pathCompleto += this.drawSectorPNOA(sym, alc_, startAngle0, endAngle0, color);
      }
    } // for
    return `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100" height="100">${pathCompleto}</svg>`;
  }
  // Devuelve el texto descodificado
  decodeNiebla(positions) {
    const neblina = [];
    positions.forEach((position) => {
      switch (position + 1) {
        case 1:
          neblina.push('RC'.concat(''));
          break;
        case 2:
          neblina.push('DGPS'.concat(''));
          break;
        case 3:
          neblina.push('AIS'.concat(''));
          break;
        case 4:
          neblina.push('RAREF'.concat(''));
          break;
        case 5:
          neblina.push('LITEPIPE'.concat(''));
          break;
        case 6:
        case 7:
        case 9:
        case 10:
        case 11:
          neblina.push('SIRENA'.concat(''));
          break;
        case 8:
          neblina.push('RACON'.concat(''));
          break;
        default:
          neblina.push('DEFAULT?'.concat(''));
      }
    });
    return (neblina);
  }
  // Devuelve la(s) imagen(es)
  decodeNie(positions) {
    const images = [];
    const this_ = this;
    positions.forEach((position) => {
      switch (position + 1) {
        case 1:
          images.push(this_.codesNie_['rc'.concat('')]);
          images.push('rc');
          break;
        case 2:
          images.push(this_.codesNie_['dgps'.concat('')]);
          images.push('dgps');
          break;
        case 3:
          images.push(this_.codesNie_['ais'.concat('')]);
          images.push('ais');
          break;
        case 4:
          images.push(this_.codesNie_['raref'.concat('')]);
          images.push('raref');
          break;
        case 5:
          images.push(this_.codesNie_['litepipe'.concat('')]);
          images.push('litepipe');
          break;
        case 6:
        case 7:
        case 9:
        case 10:
        case 11:
          images.push(this_.codesNie_['sirena'.concat('')]);
          images.push('sirena');
          break;
        case 8:
          images.push(this_.codesNie_['racon'.concat('')]);
          images.push('racon');
          break;
        default:
          images.push(this_.codesNie_['default'.concat('')]);
          images.push('');
      }
    });
    return (images);
  }

  /**
   * This function search by name, location or maritime signal
   *
   * @public
   * @function
   * @api
   */
  showResults(result) {
    this.clearResults();
    const filters = [];
    const resultTemplate = [];
    const this_ = this;
    result.forEach((elm) => {
      filters.push(elm.getAttribute('num'));
      const sym = elm.getAttribute('sym');
      const sec = elm.getAttribute('sec');
      const num = elm.getAttribute('num');
      const styles = [];
      // for cada lus
      const estiloPunto = new M.style.Point({
        icon: {
          src: './signals_v3/punto.svg',
          scale: 1,
          snaptopixel: true,
          anchor: [2.5, 2.5],
          // anchor: [parseFloat(posx0), parseFloat(posy0)],
          anchororigin: 'top-left',
          anchorxunits: 'pixel',
          anchoryunits: 'pixel',
        },
      });
      if (sym !== '133') {
        styles.push(estiloPunto);
      }
      // Poste adjunto a luces direccionales
      if (sym === '157') {
        const stylePosteGris = new M.style.Point({
          icon: {
            src: './signals_v3/poste_gris.svg',
            scale: 1,
            //  snaptopixel: true,
            anchor: [3.5, 13.5],
            anchororigin: 'top-left',
            anchorxunits: 'pixel',
            anchoryunits: 'pixel',
          },
        });
        styles.push(stylePosteGris);
      }
      // Sector 156, direccional 157
      let extrasym = ['156', '157'];
      extrasym = extrasym.includes(sym);
      // if (!M.utils.isUndefined(sym) && !extrasym) {
      if (!M.utils.isUndefined(sym)) {
        /* estilos de los simbolos */
        const cod1 = sym.substring(0, 3);
        const decodImg = this_.codesImages_['cod_'.concat(cod1)];
        const val = decodImg.split(',')[0];
        const posx = decodImg.split(',')[1];
        const posy = decodImg.split(',')[2];
        // RUMBO texto enfField
        const enfField = elm.getAttribute('enf');
        if (enfField !== undefined) { // enfilaciones TODAS!
          const g = parseFloat(enfField);
          // const svg = `<?xml version="1.0" encoding="UTF-8"?><svg id="a" xmlns="http://www.w3.org/2000/svg" width="240" height="50" viewBox="0 0 240 50"><path d="m 0,24 c 239 ,0 240,0 240,0" style="stroke:#ffffff; stroke-dasharray: 4px; stroke-width: 1px; fill:none;"/><text x="15" y="40" style="font-size: 17px; fill: #ffffff;" transform="scale(-1, 1)">Rumbo - ${enfField}</text></svg>`;
          const svg = `<?xml version="1.0" encoding="UTF-8"?><svg id="a" xmlns="http://www.w3.org/2000/svg" width="240" height="50" viewBox="0 0 240 50"><path d="m 0,24 c 239 ,0 240,0 240,0" style="stroke:#ffffff; stroke-dasharray: 4px; stroke-width: 1px; fill:none;"/><text x="15" y="40" style="font-size: 17px; fill: #ffffff;" transform="scale(-1, -1)" writing-mode="vertical-rl">Rumbo - ${enfField}</text></svg>`;
          const estiloRumbo = new M.style.Point({
            icon: {
              src: `data:image/svg+xml;base64,${window.btoa(svg)}`,
              scale: 1,
              snaptopixel: true,
              rotation: ((g + 90) * Math.PI) / 180,
              rotate: true,
              anchor: [0, 24],
              anchororigin: 'top-left',
              anchorxunits: 'pixel',
              anchoryunits: 'pixel',
            },
          });
          styles.push(estiloRumbo);
        }
        // Resto de simbolos
        const estiloGen = new M.style.Point({
          icon: {
            src: `./signals_v3/${val}`,
            scale: 1.5,
            //  snaptopixel: true,
            anchor: [parseFloat(posx), parseFloat(posy)],
            anchororigin: 'top-left',
            anchorxunits: 'pixel',
            anchoryunits: 'pixel',
          },
        });
        styles.push(estiloGen);
        // Gotas
        if (sym.length === 6) {
          const cod2 = sym.substring(3, 6);
          const decodImg2 = this_.codesImages_['cod_'.concat(cod2)];
          const val2 = decodImg2.split(',')[0];
          const posx2 = decodImg2.split(',')[1];
          const posy2 = decodImg2.split(',')[2];
          const estiloGota = new M.style.Point({
            icon: {
              src: `./signals_v3/${val2}`,
              scale: 1,
              //  snaptopixel: true,
              anchor: [parseFloat(posx2), parseFloat(posy2)],
              anchororigin: 'top-left',
              anchorxunits: 'pixel',
              anchoryunits: 'pixel',
            },
          });
          styles.push(estiloGota);
        }
        if (extrasym) {
          const svg = this.decodSectorPNOA(elm.getAttribute('sym'), elm.getAttribute('alc'), sec, elm.getGeometry().coordinates);
          const img = `data:image/svg+xml;base64,${window.btoa(svg)}`;
          const estiloSec = new M.style.Point({
            icon: {
              src: img,
              scale: elm.getAttribute('sym') === 157 ? 25 : 1.5,
              rotate: true,
              snaptopixel: true,
              anchor: [35, 35],
              anchororigin: 'top-left',
              anchorxunits: 'pixel',
              anchoryunits: 'pixel',
            },
          });
          styles.push(estiloSec);
        }
      } else {
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="50" height="50">
            <circle cx="0" cy="0" r="5" fill="none" stroke-width="3px" stroke="red" transform="scale(0.3, 0.3)" 
            transform-origin="50% 50%"/><text x="-17.5" y="5" style="font-size: 75px; font-weight: bold; fill: red;" transform="scale(0.3, 0.3)" transform-origin="50% 50%">?</text></svg>`;
        const img = `data:image/svg+xml;base64,${window.btoa(svg)}`;
        const estiloDireccional = new M.style.Point({
          icon: {
            src: img,
            scale: 1.5,
            rotate: true,
            snaptopixel: true,
            anchor: [17.5, 17.5],
            anchororigin: 'top-left',
            anchorxunits: 'pixel',
            anchoryunits: 'pixel',
          },
        });
        styles.push(estiloDireccional);
        // console.log('Luz direccional: '.concat(elm.getAttribute('num')));
      }
      let nie = elm.getAttribute('nie_');
      if (!M.utils.isUndefined(nie)) {
        nie = parseInt(nie, 10);
        nie = nie.toString(2);
        nie = nie.length >= 12 ? nie : new Array((12 - nie.length) + 1).join('0') + nie;
        nie = nie.split('').reverse().join('');
        const positions = [];
        for (let i = 0; i < 13; i += 1) {
          const value = nie.charAt(i);
          if (value === '1') {
            positions.push(i);
          }
        }
        const images = this.decodeNie(positions);
        images.forEach((image, index) => {
          if (index % 2 === 0) {
            if (image !== '') {
              styles.push(new M.style.Point({
                icon: {
                  src: `./signals_v3/${image.split(',')[0]}`,
                  scale: 1.65,
                  snaptopixel: true,
                  anchor: [parseFloat(image.split(',')[1]), parseFloat(image.split(',')[2])],
                  anchororigin: 'top-left',
                  anchorxunits: 'pixel',
                  anchoryunits: 'pixel',
                },
              }));
            }
          } else {
            const tipo = image.toUpperCase();
            let posicion_lbl = [17.5, 17.5];
            let posicion_x = 0;
            let posicion_y = 0;
            let origin = '';
            const size = 12;
            switch (tipo) {
              case 'RC':
                posicion_x = 25;
                posicion_y = 40;
                // posicion_lbl = [40, 17.5];
                origin = '100 70';
                break;
              case 'RACON':
                posicion_x = 0;
                posicion_y = 45;
                posicion_lbl = [40, 17.5];
                origin = '-10 70';
                break;
              case 'DGPS':
                posicion_x = 0;
                posicion_y = 0;
                posicion_lbl = [40, 25];
                origin = '-10 100';
                break;
              case 'AIS':
                posicion_x = 28;
                posicion_y = 0;
                posicion_lbl = [17.5, 25];
                origin = '100 100';
                break;
              default:
            }
            if (tipo === 'AIS' || tipo === 'RACON' || tipo === 'RC' || tipo === 'DGPS') {
              const svg = `<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><text x="${posicion_x}" y="${posicion_y}" style="font-size: ${size}px; fill: #ff00ff;" transform="scale(0.9 0.9)" transform-origin="${origin}">${tipo}</text></svg>`;
              // console.log('SVG estiloNieblaTxt', svg);
              const img = `data:image/svg+xml;base64,${window.btoa(svg)}`;
              const estiloNieblaTxt = new M.style.Point({
                icon: {
                  src: img,
                  scale: 1.5,
                  rotate: true,
                  snaptopixel: true,
                  // anchor: [17.5, 17.5],
                  anchor: posicion_lbl,
                  anchororigin: 'top-left',
                  anchorxunits: 'pixel',
                  anchoryunits: 'pixel',
                },
              });
              styles.push(estiloNieblaTxt);
            }
          }
        });
      }
      const st = elm.getAttribute('st');
      if (!M.utils.isUndefined(st)) {
        const estiloWarning = new M.style.Point({
          id: 'wargingSty',
          icon: {
            src: `./signals_v3/${this_.warning_.split(',')[0]}`,
            scale: 1,
            snaptopixel: true,
            anchor: [parseFloat(this_.warning_.split(',')[1]), parseFloat(this_.warning_.split(',')[2])],
            anchororigin: 'top-left',
            anchorxunits: 'pixel',
            anchoryunits: 'pixel',
          },
        });
        const stylesAux = [].concat(styles);
        setInterval(() => { this.getImpl().setStyle(elm, stylesAux); }, 2000);
        styles.push(estiloWarning);
        setInterval(() => { this.getImpl().setStyle(elm, styles); }, 4000);
      }
      const enfField = elm.getAttribute('enf');
      let g = null;
      let enf = false;
      if (!M.utils.isUndefined('enf')) {
        enf = true;
        g = parseFloat(enfField);
      }
      // Enf
      if (enf) {
        const svg = `<?xml version="1.0" encoding="UTF-8"?><svg id="a" xmlns="http://www.w3.org/2000/svg" width="240" height="25" viewBox="0 0 240 25"><path d="m 0,24 c 239 ,0 240,0 240,0" style="stroke:#ffffff; stroke-dasharray: 4px; stroke-width: 1px; fill:none;"/><text x="15" y="23" style="font-size: 17px; fill: #ffffff;">Rumbo - ${enfField}</text></svg>`;
        const styleEnf = new M.style.Point({
          icon: {
            src: `data:image/svg+xml;base64,${window.btoa(svg)}`,
            scale: 1,
            snaptopixel: true,
            rotation: ((g + 90) * Math.PI) / 180,
            rotate: true,
            anchor: [0, 24],
            anchororigin: 'top-left',
            anchorxunits: 'pixel',
            anchoryunits: 'pixel',
          },
        });
        styles.push(styleEnf);
      }
      /* eslint-disable-next-line max-len */
      if (M.utils.isUndefined(st) && M.utils.isUndefined(enf) && M.utils.isUndefined(sym) && M.utils.isUndefined(nie) && M.utils.isUndefined(sec)) {
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="50" height="50">
            <circle cx="0" cy="0" r="5" fill="none" stroke-width="3px" stroke="red" transform="scale(0.3, 0.3)" 
            transform-origin="50% 50%"/><text x="-17.5" y="5" style="font-size: 75px; font-weight: bold; fill: red;" transform="scale(0.3, 0.3)" transform-origin="50% 50%">?</text></svg>`;
        const img = `data:image/svg+xml;base64,${window.btoa(svg)}`;
        const estiloNoSimbolo = new M.style.Point({
          icon: {
            src: img,
            scale: 1.5,
            rotate: true,
            snaptopixel: true,
            anchor: [17.5, 17.5],
            anchororigin: 'top-left',
            anchorxunits: 'pixel',
            anchoryunits: 'pixel',
          },
        });
        styles.push(estiloNoSimbolo);
        // console.log('No pinta nada en la luz: '.concat(elm.getAttribute('num')));
      }
      this.getImpl().setStyle(elm, styles);

      const obj = {};
      obj.id = elm.getId();
      obj.num = elm.getAttribute('num');
      obj.ngeo = elm.getAttribute('ngeo');
      obj.c1 = elm.getAttribute('c1');
      obj.lat_ = elm.getAttribute('lat_');
      obj.lon_ = elm.getAttribute('lon_');
      obj.apa = elm.getAttribute('apa');
      obj.alc = elm.getAttribute('alc_');
      resultTemplate.push(obj);
    });
    // resultados a tabla
    const tempResults = M.template.compileSync(templateResults, {
      jsonp: true,
      vars: {
        translations: {
          maritimeSignal: getValue('maritimeSignal'),
          nationalNumber: getValue('nationalNumber'),
          name: getValue('name'),
          location: getValue('location'),
          latitudeLongitude: getValue('latitudeLongitude'),
          periodAppearance: getValue('periodAppearance'),
          elevationMeters: getValue('elevationMeters'),
          rangeMiles: getValue('rangeMiles'),
          support: getValue('support'),
          observations: getValue('observations'),
          no_results: getValue('no_results'),
        },
        resultTemplate,
      },
    });
    this.template_.querySelector('#m-maritimesignals-results').appendChild(tempResults);
    const tbody = tempResults.querySelector('tbody');
    if (!M.utils.isNull(tbody)) {
      const trs = tempResults.querySelectorAll('tr');
      trs.forEach((elm) => {
        elm.addEventListener('click', this.zoomResult_.bind(this), false);
      });
    }
    this.filterLayer(filters);
  }

  /**
   * Zoom result
   *
   * @private
   * @function
   * @api
   */
  zoomResult_(e) {
    const spl = e.currentTarget.id.split('_');
    const id = `${spl[1]}_${spl[2]}`;
    const feature = this.layer_.getFeatureById(id);
    this.map.setCenter(feature.getGeometry().coordinates);
    this.map.setZoom(20);
  }

  /**
   * This function filter layer
   *
   * @public
   * @function
   * @api
   */
  filterLayer(filters) {
    const flt = [];
    filters.forEach((filter) => {
      flt.push(M.filter.EQUAL('num', filter));
    });
    const filterOr = M.filter.OR(flt);
    this.filterSearch_ = filterOr;
    this.layer_.removeFilter(this.filtersZoom_);
    this.layer_.setFilter(filterOr);
    if (this.layer_.getFeatures().length !== 0) {
      const extent = this.layer_.getImpl().getFeaturesExtent(false, filterOr);
      this.map.setBbox(extent);
    }
    this.setConditionalZoom_();
    this.setVisibleLayer(true);
  }

  /**
   * This function show/hide layer
   *
   * @public
   * @function
   * @api
   */
  setVisibleLayer(isVisible) {
    this.layer_.setVisible(isVisible);
  }

  /**
   * This function clear results
   *
   * @public
   * @function
   * @api
   */
  clearResults() {
    this.template_.querySelector('#m-maritimesignals-results').innerHTML = '';
    this.template_.querySelector('#m-maritimesignals-input').value = '';
    this.template_.querySelector('#m-maritimesignals-cartas').value = '';
    this.filterSearch_ = [];
    this.filtersZoom_ = [];
    this.layer_.setFilter(M.filter.EQUAL('num', 'ccc'));
    this.setVisibleLayer(false);
  }

  /**
   * This function compares controls
   *
   * @public
   * @function
   * @param {M.Control} control to compare
   * @api
   */
  equals(control) {
    return control instanceof MaritimeSignalsControl;
  }
}
